import { useKeycloak } from '@react-keycloak/web';
import { useCallback, useMemo } from 'react';

import { Thumbnails } from '@/api/Thumbnails';

const useFiles = () => {
  const { keycloak } = useKeycloak();

  const apiInstance = useMemo(
    () =>
      new Thumbnails({
        headers: { Authorization: `Bearer ${keycloak.token}`, 'Content-Type': 'application/json' },
      }),
    [keycloak.token],
  );

  const downloadThumbnail = useCallback(
    async (documentId: string | number, signal?: AbortSignal) => {
      const { data } = await apiInstance.getThumbnail(
        typeof documentId === 'string' ? documentId : documentId.toString(),
        {
          format: 'blob',
          signal,
        },
      );
      return data;
    },
    [apiInstance],
  );

  return {
    downloadThumbnail,
  };
};

export default useFiles;
